import { render, staticRenderFns } from "./SaveVector.vue?vue&type=template&id=7cd46502&"
import script from "./SaveVector.vue?vue&type=script&lang=js&"
export * from "./SaveVector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports